<template>
  <div class="index">
    <div class="indexData">
      <swiper :options="swiperOption">
        <swiper-slide>
          <div class="topPro">
            <router-link :to="{name: 'productDetail',query: {categoryId:137}}">
              <img src="http://video.naolamp.com/images/index/banner1.jpg"/>
            </router-link>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="topPro">
            <router-link :to="{name: 'productDetail',query: {categoryId:138}}">
              <img src="http://video.naolamp.com/images/index/banner2.jpg"/>
            </router-link>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="topPro">
            <router-link :to="{name: 'productDetail',query: {categoryId:146}}">
              <img src="http://video.naolamp.com/images/index/banner3.jpg"/>
            </router-link>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
    </div>
    <div class="index_bottom">
      <div class="bottom_title">热销产品</div>
      <div class="bottom_list">
        <router-link class="img_href" :to="{name: 'productDetail',query: {categoryId:146}}">
          <img src="http://video.naolamp.com/images/index/index_rx1.jpg"/>
        </router-link>
        <router-link class="img_href"  :to="{name: 'productDetail',query: {categoryId:138}}">
          <img src="http://video.naolamp.com/images/index/index_rx2.jpg"/>
        </router-link>
        <router-link class="img_href"  :to="{name: 'productDetail',query: {categoryId:137}}">
          <img src="http://video.naolamp.com/images/index/index_rx3.jpg"/>
        </router-link>
        <img src="http://video.naolamp.com/images/index/index_rx4.jpg"/>
      </div>
    </div>
    <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
  </div>
</template>

<script>
import loading from './common/loading.vue'
export default {
  name: 'userMain',
  data () {
    const that = this
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          // height: 700,
          clickable: true,
          renderBullet (index, className) {
            return `<div class="${className}">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" preserveAspectRatio="none">
                <circle cx="7" cy="7" r="6"></circle>
                </svg></div>`
          },
          dynamicBullets: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        loop: true,
        on: {
          slideChangeTransitionStart: function () {
            // console.log(this.realIndex)
            if (this.realIndex === 2) {
              that.$store.commit('setHeadColor', 'newsList')
            } else {
              that.$store.commit('setHeadColor', 'index')
            }
          }
        },
        autoplay: {
          delay: 4500,
          disableOnInteraction: false
        }
      },
      msg: '个人首页',
      isLoad: false
    }
  },
  computed: {
  },
  mounted: function (s) {
    // console.log(this.getUrlParms('code'))
  },
  methods: {
  },
  filters: {
  },
  components: {
    loading
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  text-align: center;
  width: 100%;
  min-width: 1200px;
  border-bottom: 1px solid #e8e8e8;
}
.topPro {
  max-width: 1920px;
}
.swiper-container {
  max-width: 1920px;
  /*height: 700px;*/
}
.swiper-pagination-bullets {
  bottom: 30px;
}
.topPro img {
  width: 100%;
  height: auto;
}
.top1 .float {
  width: 30%;
  position: absolute;
  left: 60%;
  top: 35%;
}
.topPro .float {
  position: absolute;
  color: white;
  top: 15%;
  width: 100%;
  min-width: 1200px;
}
.topPro .float div {
  text-align: left;
  width: 1200px;
  margin: 0 auto;
}

.topPro .float p {
  font-size: 30px;
}
.topPro .float p:first-child{
  font-family: "FZYH_510M";
  margin-bottom: 10px;
  font-size: 52px;
}
.topPro .float p:last-child{
  margin-top: 50px;
  font-size: 18px;
}
.index_bottom {
  /*width: 100%;*/
  min-width: 1200px;
  text-align: center;
  margin: 0 auto;
  background-color: #F2F2F2;
}
.index_bottom .bottom_title {
  font-size: 29px;
  color: #2e2e2e;
  padding-top: 74px;
  padding-bottom: 73px;
}
.index_bottom .bottom_list {
  padding-bottom: 106px;
  display: flex;
  justify-content: center;
}
.img_href img {
  flex: 1;
  padding-right: 14px;
}
.img_href:last-child img {
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue